export default __webpack_public_path__ + "static/media/empty-ellipse.a206f964.svg";